import React, {Component} from 'react';
import {connect} from 'react-redux';
import './VersionPreview.css';

export const VersionPreview = ({items}) => (
	<section className="VersionPreview">
		<table>
			<thead>
			<tr>
				<th/>
				<th>Code</th>
				<th>Area Code</th>
				<th>Area Name</th>
				<th>Strand</th>
				<th>Name</th>
				<th>Details</th>
				<th/>
			</tr>
			</thead>
			<tbody>
			{items ? items.map((item, index) => (
				[
					<tr key={`${item.code}_${index}`}>
						<td className="VersionPreview-row">{index + 2}</td>
						<td>{item.code}</td>
						<td>{item.area_code}</td>
						<td>{item.area_name}</td>
						<td>{item.strand}</td>
						<td>{item.name}</td>
						<td>{item.details}</td>
						<td className="VersionPreview-warning"/>
					</tr>,
					item.content && item.content.length ? (
						<tr key={`${item.code}_${index}_subcontent`} className="VersionPreview-subcontent">
							<td colSpan="8">
								<table>
									<thead>
									<tr>
										<th/>
										<th>Code</th>
										<th>Year</th>
										<th>Context</th>
										<th>Contents</th>
										<th/>
									</tr>
									</thead>
									<tbody>
									{item.content.map((content, index) => (
										<tr key={`${item.code}_${content.code}_${index}`}>
											<td className="VersionPreview-row">{content.line}</td>
											<td>{content.code}</td>
											<td>{content.year}</td>
											<td>{content.context}</td>
											<td>{content.contents}</td>
											<td className="VersionPreview-warning"/>
										</tr>
									))}
									</tbody>
								</table>
							</td>
						</tr>
					) : null
				]
			)) : null}
			</tbody>
		</table>
	</section>
);

const ConnectedVersionPreview = connect(
	({syllabus}, {location, match: {params: {setID, versionID}}}) => ({
		items: syllabus.versions.items && syllabus.versions.items.find(version => version.uuid === versionID) && syllabus.versions.items.find(version => version.uuid === versionID).items
	})
)(VersionPreview);

export default ConnectedVersionPreview;


// WEBPACK FOOTER //
// ./src/syllabus/VersionPreview.js